export type OverviewInvoiceDocumentType =
  | 'offer'
  | 'invoice'
  | 'partial_invoice'
  | 'final_invoice'
  | 'credit_note'
  | 'invoice_correction';

export function overviewDocumentTypeFromGermanLabel(
  label: string | null | undefined,
): OverviewInvoiceDocumentType | null {
  const value = String(label ?? '').trim().toLowerCase();
  if (value === 'angebot') return 'offer';
  if (value === 'rechnung') return 'invoice';
  if (value === 'abschlagsrechnung') return 'partial_invoice';
  if (value === 'schlussrechnung') return 'final_invoice';
  if (value === 'stornorechnung') return 'credit_note';
  if (value === 'gutschrift') return 'invoice_correction';
  return null;
}

export function invoicesListTabForDocumentType(
  documentType: OverviewInvoiceDocumentType,
): 'quotes' | 'outgoing' {
  return documentType === 'offer' ? 'quotes' : 'outgoing';
}

export function uniqueDocumentNumbers(
  items: Array<{ invoice_number?: string | null; reference_id?: string | null }>,
): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of items) {
    const number = String(item.invoice_number ?? item.reference_id ?? '').trim();
    if (!number || seen.has(number)) continue;
    seen.add(number);
    out.push(number);
  }
  return out;
}

export const DUPLICATE_DOCUMENT_WARNING_QUESTION =
  'Bist du dir sicher, dass dieses Dokument erneut erstellt werden soll?';

export function formatDuplicateDocumentWarning(input: {
  documentTypeLabel: string;
  existingNumbers: string[];
  nextNumber: string;
}): { body: string; question: string } {
  const numbers = input.existingNumbers.join(', ');
  return {
    body: `Es liegt bereits ${input.documentTypeLabel} ${numbers} vor mit denselben Angaben und abweichender Nummer. Dieses Dokument würde eine neue Nummer erhalten (${input.nextNumber}).`,
    question: DUPLICATE_DOCUMENT_WARNING_QUESTION,
  };
}

/** Warn when download/send would allocate a new number while older copies already exist. */
export function shouldWarnNewDocumentNumber(input: {
  documentNumberCommitted: boolean;
  previewReferenceId: string;
  existingNumbers: string[];
}): { warn: boolean; existingNumbers: string[] } {
  if (input.documentNumberCommitted) {
    return { warn: false, existingNumbers: [] };
  }
  const preview = input.previewReferenceId.trim();
  const others = input.existingNumbers
    .map((value) => value.trim())
    .filter((value) => value && value !== preview);
  return { warn: others.length > 0, existingNumbers: others };
}
